export const PathName = {
  Login: '/',
  Dashboard: '/dashboard',
  ForgotPassword: '/forgot-password',
  ResetPassword: '/reset-password',
  NotFound: '*',
};
